import { GLOSSARY_TERM_WP_TYPE } from '../../contentTypes/glossaryTerm';
import { returnTemplate } from '../../lib/_client';
import { returnStaticProps } from '../../lib/_helpers';
import GlossaryTerm from '../../templates/glossary/Single';

export default function Template(props) {
  return returnTemplate(props, GlossaryTerm);
}

export async function getStaticPaths() {
  return {
    fallback: 'blocking',
    paths: [],
  };
}

export async function getStaticProps(props) {
  return await returnStaticProps({
    ...props,
    type: GLOSSARY_TERM_WP_TYPE,
  });
}
